var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 0C2.58333 0 0 2.58333 0 5.83333V14.1667C0 17.4167 2.58333 20 5.83333 20H14.1667C17.4167 20 20 17.4167 20 14.1667V5.83333C20 2.58333 17.4167 0 14.1667 0H5.83333ZM15.8333 3.33333C16.3333 3.33333 16.6667 3.66667 16.6667 4.16667C16.6667 4.66667 16.3333 5 15.8333 5C15.3333 5 15 4.66667 15 4.16667C15 3.66667 15.3333 3.33333 15.8333 3.33333ZM10 5C12.75 5 15 7.25 15 10C15 12.75 12.75 15 10 15C7.25 15 5 12.75 5 10C5 7.25 7.25 5 10 5ZM10 6.66667C8.16667 6.66667 6.66667 8.16667 6.66667 10C6.66667 11.8333 8.16667 13.3333 10 13.3333C11.8333 13.3333 13.3333 11.8333 13.3333 10C13.3333 8.16667 11.8333 6.66667 10 6.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8a4603b4ebf0d2eb3863afefcae42c29.svg";
export { ForwardRef as ReactComponent };